<template>
  <div>
    <v-card-title>Alternatively, these providers may be able to help</v-card-title>

    <template
      v-if="advertsType === 'overture'"
    >
      <v-card
        v-for="(advert, index) in adsList"
        :key="index"
        elevation="1"
        class="d-flex pa-4 justify-space-between align-center"
        :class="{ 'mt-3': index > 0 }"
        width="100%"
      >
        <div style="max-width: 65%;">
          <h3
            class="primary--text text-limit font-weight-bold mb-1"
            v-html="advert.title"
          />
          <p
            class="text-limit ma-0 mb-1"
            v-html="unescape(advert.description)"
          />
          <a
            v-if="advert.host"
            class="text-break"
            @click.prevent="goToWebsite(advert.link)"
          > {{ decodeURIComponent(advert.host) }}</a>
        </div>
        <v-btn
          class="ml-2"
          color="primary"
          @click.prevent="goToWebsite(advert.link)"
        >
          Visit website
        </v-btn>
      </v-card>
    </template>

    <template
      v-if="advertsType === 'directory'"
    >
      <v-card
        v-for="(advert, index) in adsList"
        :key="index"
        elevation="1"
        class="adverts-directory justify-space-between align-start"
        :class="{'d-flex': $vuetify.breakpoint.smAndUp, 'mt-3': index > 0}"
        width="100%"
      >
        <div
          :class="{
            'col-md-8': $vuetify.breakpoint.smAndUp,
            'd-flex': $vuetify.breakpoint.xsOnly,
            'flex-column': $vuetify.breakpoint.xsOnly,
            'align-items': $vuetify.breakpoint.xsOnly,
          }"
        >
          <h3
            class="d-flex align-self-center"
          >
            <a

              :id="advert.id"
              class="primary--text text-limit text-h6 font-weight-bold mb-3"
              target="_blank"
              :href="advert.link"
              :refid="advert.refId"
              :adtitle="advert.title"
              v-html="advert.title"
            />
          </h3>

          <a
            v-if="$vuetify.breakpoint.xsOnly"
            :id="advert.id"
            class="align-self-center"
            target="_blank"
            :href="advert.link"
            :refid="advert.refId"
            :adtitle="advert.title"
          >
            <img
              class="mb-3"
              :src="advert.imageFile"
              alt="ads-img"
            >
          </a>
          <p
            class="ma-0 mb-1"
            :class="{'mb-3': $vuetify.breakpoint.xsOnly}"
            v-html="unescape(advert.description)"
          />
        </div>
        <div
          class=" d-flex flex-column align-center"
          :class="{'col-md-3': $vuetify.breakpoint.smAndUp}"
        >
          <form
            method="POST"
            :action="advert.link"
            target="_blank"
          >
            <button type="submit">
              <img
                v-if="$vuetify.breakpoint.smAndUp"
                class="mb-5"
                :src="advert.imageFile"
                alt="ads-img"
              >
            </button>

            <v-btn
              value="submit"
              type="submit"
              x-large
              color="success"
              block
            >
              Get Quotes
            </v-btn>
          </form>
        </div>
      </v-card>
    </template>
  </div>
</template>

<script>
import { unescape } from 'lodash';

export default {
  name: 'adverts-list',
  props: {
    adsList: {
      type: Array,
      required: true,
    },
    advertsType: {
      type: String,
      required: true,
    },
  },
  methods: {
    goToWebsite (url) {
      window.open(url, '_blank').focus();
    },
  },
  setup () {
    return { unescape };
  },
};
</script>

<style scoped lang='scss'>
.v-card__title {
  word-break: normal;
}

.text-limit {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.adverts-directory {
  padding: 20px 15px;

  .advert-link {
    display: block;
    width: 100%;
  }

  img {
    width: 100%;
    max-width: 240px;
  }
}

@media screen and (min-width: 768px) {
  .adverts-directory {
    padding: 25px 100px;

    img {
      max-width: none;
    }
  }
}
</style>
